export enum GoToCourseEvent {
  goToCourseButton = 'go_to_course_page_button_more details',
  goToCourseCard = 'go_to_course_page_card',
}
